import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const LS_KEY = "bodios:cart";

function loadCart() {
  try {
    const saved = localStorage.getItem(LS_KEY);
    console.log('📦 Loading cart from localStorage:', saved); // Debug
    return saved ? JSON.parse(saved) : [];
  } catch (err) {
    console.error('❌ Failed to load cart:', err);
    return [];
  }
}

function saveCart(items) {
  try {
    const json = JSON.stringify(items);
    localStorage.setItem(LS_KEY, json);
    console.log('💾 Saved cart to localStorage:', json); // Debug
    return items;
  } catch (err) {
    console.error('❌ Failed to save cart:', err);
    return items;
  }
}

const makeKey = (id, color, size) => `${id}__${color || ""}__${size || ""}`;

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState(() => {
    const loaded = loadCart();
    console.log('🚀 Initial cart state:', loaded); // Debug
    return loaded;
  });

  // ✅ cartItems өөрчлөгдөх бүрт хадгална
  useEffect(() => {
    saveCart(cartItems);
  }, [cartItems]);

  const addToCart = (item, qty = 1) => {
    const key = makeKey(item.id, item.color, item.size);
    console.log('➕ Adding to cart:', { item, qty, key }); // Debug
    
    setCartItems((prev) => {
      const idx = prev.findIndex((x) => x.key === key);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        console.log('✅ Updated existing item:', next[idx]); // Debug
        return next;
      }
      const newItem = { ...item, key, quantity: Math.max(1, qty) };
      console.log('✅ Added new item:', newItem); // Debug
      return [...prev, newItem];
    });
  };

  const updateQty = (key, qty) => {
    console.log('🔄 Updating quantity:', { key, qty }); // Debug
    setCartItems((prev) =>
      prev.map((x) => (x.key === key ? { ...x, quantity: Math.max(1, qty) } : x))
    );
  };

  const removeFromCart = (key) => {
    console.log('🗑️ Removing from cart:', key); // Debug
    setCartItems((prev) => prev.filter((x) => x.key !== key));
  };

  const clearCart = () => {
    console.log('🧹 Clearing cart'); // Debug
    setCartItems([]);
  };

  const total = useMemo(
    () => cartItems.reduce((s, x) => s + Number(x.price || 0) * Number(x.quantity || 0), 0),
    [cartItems]
  );

  const value = { cartItems, addToCart, updateQty, removeFromCart, clearCart, total };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}